function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.65009 8.375H18.3501M3.65009 13.625H18.3501M10.5624 3.125C9.08835 5.48716 8.30685 8.21563 8.30685 11C8.30685 13.7844 9.08835 16.5128 10.5624 18.875M11.4375 3.125C12.9116 5.48716 13.6931 8.21563 13.6931 11C13.6931 13.7844 12.9116 16.5128 11.4375 18.875M3.125 11C3.125 12.0342 3.32869 13.0582 3.72445 14.0136C4.1202 14.9691 4.70027 15.8372 5.43153 16.5685C6.1628 17.2997 7.03093 17.8798 7.98637 18.2756C8.94181 18.6713 9.96584 18.875 11 18.875C12.0342 18.875 13.0582 18.6713 14.0136 18.2756C14.9691 17.8798 15.8372 17.2997 16.5685 16.5685C17.2997 15.8372 17.8798 14.9691 18.2756 14.0136C18.6713 13.0582 18.875 12.0342 18.875 11C18.875 8.91142 18.0453 6.90838 16.5685 5.43153C15.0916 3.95469 13.0886 3.125 11 3.125C8.91142 3.125 6.90838 3.95469 5.43153 5.43153C3.95469 6.90838 3.125 8.91142 3.125 11Z",
    stroke: "#6B7280",
    style: {
      stroke: "#6B7280",
      stroke: "color(display-p3 0.4196 0.4471 0.5020)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/web-icon.5d142c6523dadc0fef5f93a627ee8530.svg";
export { ForwardRef as ReactComponent };